import { render } from "./BlogPreventiveSleepApnea.vue?vue&type=template&id=6aeb4590"
import script from "./BlogPreventiveSleepApnea.vue?vue&type=script&lang=js"
export * from "./BlogPreventiveSleepApnea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__